import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivateFn } from '@angular/router';

import { InvoiceValidationWorkspaceComponent } from '../components/invoice-validation-workspace/invoice-validation-workspace.component';
import { openInvoiceValidationDiscardDialog } from './invoice-validation-discard-dialog';

export const invoiceValidationDirtyGuard: CanDeactivateFn<InvoiceValidationWorkspaceComponent> = (
  component,
) => {
  if (!component || !component.hasChanges()) {
    return true;
  }

  const dialog = inject(MatDialog);
  return openInvoiceValidationDiscardDialog(dialog);
};
